/**
 * Returns Firebase auth token from server storage (e.g. cookie). Stub: returns null.
 * Implement when using SSR with authenticated Hasura queries.
 */
export async function getFirebaseAuthToken(): Promise<string | null> {
  return null;
}
